import React, { useEffect, useState } from 'react'
import Api from '../../../pages/api/api'
import Progress from '../../modules/progress/progress'
import VulnerCollapseCard from '../../modules/vulner_collapse_card'
import NotFoundResult from '../not_found_result'
import strings from '../../strings/strings.json'
import styles from './vulns_render.module.css'
import VulnsWaiting from '../vulns_waiting'

export default function VulnsRender(props) {

    const type = JSON.parse(localStorage.getItem(props.type))
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [total, setTotal] = useState()

    useEffect(() => {
        if (!type && !props.isVulns) {
            setIsLoading(true)
            if (props.data !== undefined &&
                props.data !== 0) {
                Api.getVulns({
                    "hash": props.data.sha256,
                    "type": props.type
                })
                    .then(result => {

                        setData(result.result)
                        localStorage.setItem(`${props.type}`, JSON.stringify([{
                            "total": result.total,
                        },
                        {
                            "result": result.result
                        }
                        ]))
                        setTotal(result.total)
                        setIsLoading(false)
                    })
                    .catch(err => {
                        setIsLoading(false)
                        console.log('vulner error', err)
                    })
            }
        }
    }, [props.type, props.data, props.isVulns])


    const vulnsMapHandler = (data, index) => {
        return (
            <div key={index}>
                <VulnerCollapseCard data={data} />
            </div>
        )
    }

    const colorHandler = () => {
        switch (props.type) {
            case "high":
                return '#e6185c'
            case "low":
                return '#fcad53'
            case "lib":
                return '#7ea7ff'
            default:
        }
    }


    if (isLoading) return (<Progress css={styles.vulns_progress} />)
    if ((type && type[1].result.length === 0 && !isLoading) &&
        (data === null ||
            data.length === 0))
        return (<NotFoundResult />)

    return (

        <div style={{padding:"20px"}} className="vulns_container shadow_white">
            <React.Fragment>
                {
                    props.isVulns ?
                        <VulnsWaiting hash={props.data.sha256} uploader_email_exists={props.data.uploader_email_exists && props.data.uploader_email_exists} />
                        :
                        <React.Fragment>
                            {
                                data.length === 0 ?
                                    type && type[1].result.map(vulnsMapHandler)
                                    :
                                    data.map(vulnsMapHandler)
                            }
                            {
                                ((data.length !== 0 && (data.length < total)) || (type && (type[1].result.length < type[0].total))) &&
                                <div style={{ backgroundColor: colorHandler() }} className={styles.warning_container}>
                                    <span className={styles.warning_span}>فقط {data.length !== 0 ? data.length : type[1].result.length} از {data.length !== 0 ? total : type[0].total} {strings.fileDetails_gotoBusiness}</span>
                                </div>
                            }
                        </React.Fragment>
                }
            </React.Fragment>

        </div>
    )
}
